<template>
    <LinkHover
        :type="'button'"
        :classNames="{
            default: 'link-default',
            hover: 'link-hover',
            hoverMask: 'link-hover-mask',
        }"
        @click.native="onClick"
        :class="['picture']"
    >
        <div class="default">
            <div
                class="bg-image"
                :style="{backgroundImage: `url(${ layout.highlight.image.url })`}"
            >
                <img
                    :src="layout.highlight.image.url"
                    :alt="layout.highlight.image.alt"
                    :title="layout.highlight.image.title"
                    class="seo-image"
                />
            </div>
            <div class="bg-grey"></div>
            <div class="bg-cross"></div>
            <div class="container">
                <div
                    class="tag-container"
                >
                    <span class="tag">{{tag}}</span>
                </div>
                <div
                    class="heading"
                    v-html="layout.highlight.heading"
                ></div>
            </div>
            <div class="footer">
                <span class="date">{{layout.date}}</span>
            </div>
        </div>
        <template v-slot:hover>
            <div class="hover">
                <div
                    class="bg-image"
                    :style="{backgroundImage: `url(${ layout.highlight.image.url })`}"
                >
                    <img
                        :src="layout.highlight.image.url"
                        :alt="layout.highlight.image.alt"
                        :title="layout.highlight.image.title"
                        class="seo-image"
                    />
                </div>
                <div class="bg-black"></div>
                <div class="container">
                    <div
                        class="tag-container"
                    >
                        <span class="tag">{{tag}}</span>
                    </div>
                    <div
                        class="heading"
                        v-html="layout.highlight.heading"
                    ></div>
                </div>
                <div class="footer">
                    <span class="date">{{layout.date}}</span>
                </div>
            </div>
        </template>
    </LinkHover>
</template>
<script>
import LinkHover from '@/components/animation/LinkHover'
import {popin} from '@/store/index.js'
export default {
    components: {
        LinkHover,
    },
    props: {
        layout: {
            type: Object,
            default() {}
        }
    },
    computed: {
        tag() {
            const tag = this.layout.tagLabel ? this.layout.tagLabel[0] : false
            return tag ? tag.name : this.$t('common.picture')
        }
    },
    methods: {
        onClick() {
            // throw new Error('Todo: add popin')
            popin.data = this.layout
            popin.state = true
        }
    }
}
</script>
<style lang="sass" scoped>
@import "@/styles/vars.sass"
.picture
.default, .hover
    // padding-top: 178px
    // padding-right: 75px
    // padding-bottom: 85px
    // padding-left: 85px
    text-align: left
    flex-direction: column
    display: flex
    // @include media-breakpoint-down($sm)
    //     padding-top: 145px
    //     padding-right: 51px
    //     padding-bottom: 69px
    //     padding-left: 69px
.bg-image, .bg-grey, .bg-cross, .bg-black
    position: absolute
    top: 0
    left: 0
    width: 100%
    height: 100%
.bg-image
    background-position: 50% 50%
    background-repeat: no-repeat
    background-size: cover
    z-index: -5
    .default &
        filter: grayscale(1)
    .hover &
        opacity: 0.8
.bg-grey
    background: #808185
    z-index: -4
    opacity: 0.8
.bg-black
    background: #000000
    z-index: -3
    opacity: 0.2
.bg-cross
    z-index: -1
    background: url('./../../../assets/cross.svg') repeat center
    background-size: 45px 45px
    background-position: 0 0
    opacity: 0.2
.container
    flex: 1
    display: flex
    flex-direction: column
.heading
    flex: 0.5648148148
.tag-container
    flex: 0.3
.container
    /deep/ h1,
    /deep/ h2,
    /deep/ h3,
    /deep/ h4,
    .tag
        color: #ffffff
.footer
    .date
        color: #ffffff
</style>
